<template>
  <PopWrap btnText="继续" @clicked="handleBtnClick">
    <div class="video-graphic">
      <div v-if="characterInfo" class="character flex items-center flex-wrap">
        <img class="graphic-avatar" :src="characterInfo.avatar" alt="" />
        <span>{{ characterInfo.name }}</span>
      </div>
      <div class="graphoc-content prose text-motif-font-300" v-html="contentHtml" />
    </div>
  </PopWrap>
</template>

<script lang="ts">
import { Vue, Prop, Component } from 'vue-property-decorator';
import PopWrap from '../VideoPopWrap';
import showdown from 'showdown';
import { Content } from '@forchange/storytime';

@Component({
  components: {
    PopWrap
  }
})
export default class Graphic extends Vue {
  @Prop() characters!: { name: string; avatar: string }[];
  @Prop({ type: Object }) content!: Content & {
    name: string;
    content: string;
  };

  get characterInfo() {
    return this.characters?.find((item) => item.name === this.content.name);
  }

  get contentHtml() {
    const converter = new showdown.Converter({
      simpleLineBreaks: true,
      openLinksInNewWindow: true
    });
    return converter.makeHtml(this.content.content);
  }

  handleBtnClick() {
    this.$emit('next');
  }
}
</script>

<style lang="scss" scoped>
.video-graphic {
  position: relative;
  min-height: 48px;
  padding: 0 4px;
  .character {
    margin-top: 5px;
    padding-bottom: 10px;
    color: #2b3439;
    font-weight: 500;
    font-size: 13px;
    line-height: 18px;
  }
  .graphic-avatar {
    width: 24px;
    height: 24px;
    margin-right: 5px;
    border-radius: 50%;
  }
}
</style>
<style lang="scss">
.video-graphic .graphoc-content {
  position: relative;
  max-width: 100%;
  margin-top: 5px;

  &:last-child {
    margin-bottom: 0;
  }
  img {
    max-width: 100%;
    margin-top: 20px;
    border-radius: 8px;
    &:last-child {
      margin-bottom: 0 !important;
    }
  }
  p {
    &:last-child {
      margin-bottom: 0 !important;
    }
  }
}
</style>
